<template>
  <slot v-if="disabled"></slot>
  <HoverCard v-else placement="right">
    <template #trigger>
      <slot></slot>
    </template>
    <template #content>
      <div class="px-3 py-2">
        <div class="whitespace-nowrap text-sm font-semibold leading-6 text-gray-700">
          {{ label }}
        </div>
        <div v-if="warning" class="mt-1 flex max-w-xs items-start gap-x-1.5 text-xs text-amber-600">
          <ExclamationTriangleIcon class="size-4 shrink-0" />
          <span>{{ warning }}</span>
        </div>
      </div>
    </template>
  </HoverCard>
</template>

<script setup lang="ts">
import { ExclamationTriangleIcon } from '@heroicons/vue/20/solid';

import HoverCard from '@/components/HoverCard.vue';

defineProps<{
  label: string;
  warning?: string;
  /** Render the trigger without a hover card (for the expanded sidebar, where labels are visible). */
  disabled?: boolean;
}>();
</script>
